<form nz-form class="form mt-16" [formGroup]="filterForm" nzLayout="horizontal">
  <div class="header-wrapper">
    <!-- Time Range Segmented Control -->
    <nz-segmented
      class="segment-field"
      [class.isCustomDateSelected]="isCustomDateSelected"
      id="time-segment"
      [nzOptions]="timeRangeOptions"
      formControlName="timeOption"
      (nzValueChange)="onTimeRangeChange($event)">
    </nz-segmented>

    <!-- Custom Date Range Picker -->
    <nz-form-item class="timeline-field">
      <nz-form-label nzFor="graph">Timeline</nz-form-label>
      <nz-form-control>
        <nz-range-picker
          class="w-100"
          [nzFormat]="dateFormat"
          formControlName="filterDateRange"
          [nzAllowClear]="false">
        </nz-range-picker>
      </nz-form-control>
    </nz-form-item>

    <!-- View Type Select -->
    <nz-form-item>
      <nz-form-label nzFor="viewType">View Type</nz-form-label>
      <nz-form-control>
        <nz-select
          nzPlaceHolder="Select viewType"
          formControlName="viewType"
          [nzOptionOverflowSize]="7">
          <nz-option
            *ngFor="let item of enabledViewTypeOptions"
            [nzLabel]="item.label"
            [nzValue]="item.value">
          </nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- Trend Line Checkbox -->
    <nz-form-item>
      <span nz-checkbox formControlName="isTrendLineEnabled">
        Show Trend Line
      </span>
    </nz-form-item>
  </div>
</form>
